'use client'
import {
  forwardRef,
  StepSeparator as ChakraStepSeparator,
} from '@chakra-ui/react'
import { LegacyRef } from 'react'

import { StepSeparatorProps } from './StepSeparator.types'

export default forwardRef(function StepSeparator(
  props: StepSeparatorProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraStepSeparator {...props} ref={ref} translate="no" />
})
